module.exports = __webpack_public_path__ + "img/scene.88a74f72.png";